import script from "./HelpAgentWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpAgentWidget.vue?vue&type=script&setup=true&lang=js"

import "./HelpAgentWidget.vue?vue&type=style&index=0&id=d0aca2c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0aca2c2"]])

export default __exports__